import AppAuthorizationPage from './AppAuthorizationPage';
import AppAuthorizationPageContainer from './AppAuthorizationPage.container';

export default AppAuthorizationPageContainer(AppAuthorizationPage);
